<template>
  <Modal v-if="src != false && src != '#'" :attr="attr" :store="store" :config="modalConfig">
    <template v-slot:header>
      <a href="#close" class="close-modal" @click="closeModal()"></a>
    </template>
    <template v-slot:body>
      <div class="main-thumbnail">
        <img class="cover" :src="src" />
        <img class="contain" :src="src" />
      </div>
    </template>
    <template v-slot:footer><span></span></template>
  </Modal>
</template>

<script>
import Modal from './../BaseModal.vue'
export default {
  components: {
    Modal
  },
  computed: {
    attr() {
      return {
        id: 'image-preview',
        class: 'image-preview'
      }
    },
    modalConfig() {
      let config = _.cloneDeep(this.config)
      config.keys = config.keys.concat(['_visible'])
      return config
    },
    value() {
      return this.store.getter(this.config?.keys, {})
    },
    src() {
      return this.value.src != null ? this.value.src : '#'
    }
  },
  methods: {
    closeModal() {
      let keys = this.config?.keys.concat(['_visible'])
      this.store.commit(keys, false)
    }
  },
  props: {
    store: {
      type: Object,
      default() {
        return {}
      }
    },
    config: Object
  }
}
</script>
<style lang="scss">
.modal.image-preview {
  width: 100%;
  .modal-header {
    position: absolute;
    width: 0;
    height: 0;
    padding: 0;
    background: 0;
  }
  .modal-footer {
    display: none;
  }
  .modal-dialog {
    padding: 0;
    margin: 0;
    width: 100%;
    height: 100%;
    max-width: 100%;
    overflow: hidden;
  }
  .modal-content {
    border: 0;
    height: 100%;
    background-color: transparent;
  }
  .modal-body {
    padding: 0;
    height: 100%;
    background: 0;
  }
  .close-modal {
    position: fixed;
    top: 15px;
    left: 15px;
    width: 40px;
    height: 40px;
    background: #fff;
    display: block;
    border: 1px solid #ccc;
    border-radius: 50%;
    z-index: 999;
  }

  .main-thumbnail {
    flex: 1;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    img {
      max-width: 100%;
      max-height: 100%;
      position: absolute;
      z-index: 1;
      -o-object-fit: contain;
      object-fit: contain;
      &.cover {
        z-index: -1;
        width: 100%;
        height: 100%;
        -o-object-fit: cover;
        object-fit: cover;
        filter: blur(8px);
      }
    }
  }
}
</style>
